import { createSlice } from '@reduxjs/toolkit';
import { TechSupportState } from './models';

const initialState: TechSupportState = {
  currentUser: null,
  isLoading: false,
  error: '',
};

const customerSupportSlice = createSlice({
  name: 'customerSupportSlice',
  initialState,
  reducers: {
    setCurrentData: (state, action) => {
      state.currentUser = action.payload;
    },
  },
});

export default customerSupportSlice.reducer;
